import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpNotificationIconComponent from './adpNotificationIcon.component';

let adpNotificationIconModule = angular.module('adpNotificationIcon', [
  uiRouter
])

.component('adpNotificationIcon', adpNotificationIconComponent)

.name;

export default adpNotificationIconModule;



// WEBPACK FOOTER //
// ./src/app/components/adpNotificationIcon/adpNotificationIcon.js